import MultipartQuestion from "../../models/multipart-question";
import BaseComponent from "../base-component.js";
import { h } from "preact"
import rubricReport from "./rubric-report";
import { hide } from "@floating-ui/dom";

const inlineResponseTypes = [
    "inline-choice",
    "fill-in-the-blank",
    "gap-match"
]


export default class MultipartReportComponent extends BaseComponent {
    responseCollector() {
        if (!(this.props.item instanceof MultipartQuestion)) return;
        let item = this.props.item;
        if( !this.props.scoringData || Array.isArray(this.props.scoringData) || !("multipart" in this.props.scoringData)) {
            throw new Error("Scoring data must be an object");
        }

        let scoringData = this.props.scoringData.multipart;

        return <div class="multipart-container">
            {item.parts.map((part, index) => {
                let partId = (part.attributes.assessment_item_id != null ? Number(part.attributes.assessment_item_id): Number(part.id));
                let partScoringData = scoringData.find((partScoringData) => {
                    return partScoringData.question_part_id == partId 
                })
                if(!partScoringData) { throw new Error("Scoring data not found for part " + partId); }
                return this.renderPart(part, index, partScoringData)
            })}
        </div>
    }

    /**
     * 
     * @param {import("../../models/question").default} part 
     * @param {number} index
     * @param {import("../../shared-types").MultipartScoringData} scoringData
     */
    renderPart(part, index, scoringData) {
        let isSingleColumnPart = isTeacherScored(part) 
        let hideCorrectAnswer = isSingleColumnPart || this.props.hideAllAnswers || (this.props.hideCorrectAnswers && scoringData.status == "correct");
        let hideResponse = this.props.hideResponse;

        let reportComponents = [];

        if(!hideResponse) {
            reportComponents.push(this.renderPartReport(part, scoringData));
        }

        if(!hideCorrectAnswer) {
            reportComponents.push(this.renderPartPreview(part));
        }

        if(hideResponse && hideCorrectAnswer) {
            reportComponents.push(this.renderPlainPart(part));
        }

        return <div class="multipart-part">
            <div class={"multipart-header " + scoringData.status}>
                {"Part " + String.fromCharCode(index+65)}
                <div class="multipart-part-score">Score {`${scoringData.points} / ${scoringData.max_points}`}</div>
            </div>
            <div class="multipart-part-report-body" dangerouslySetInnerHTML={{__html: part.body}}>
            </div>
            <div class="multipart-part-report-container-header">
                {hideResponse ? null : <div class="multipart-part-report-container-header-label">Your Answer</div>}
                {hideCorrectAnswer ? null : <div class="multipart-part-report-container-header-label">Correct Answer</div>}
            </div>
            <div class="multipart-part-report-container">
                {reportComponents}
            </div>
        </div>
    }

    /**
     * @param {import("../../models/question").default} part 
     */
    renderPartPreview(part) {
        return <div class="multipart-part-preview">
            {h(part.component("preview"), {
                ...this.props, ...{
                    showBody: inlineResponseTypes.includes(part.responseType),
                    item: part,
                }
            })}
        </div>
    }

    /**
     * @param {import("../../models/question").default} part 
     * @param {import("../../shared-types").MultipartScoringData} scoringData
     */
    renderPartReport(part, scoringData) {
        console.assert(part.attributes.assessment_item_id != null, "Part does not have an assessment item id");
        let partId = Number(part.attributes.assessment_item_id);
        return <div class="multipart-part-report">
            {h(part.component("student-facing-report"), {
                ...this.props, ...{
                    showBody: inlineResponseTypes.includes(part.responseType),
                    item: part,
                    scoringData: scoringData.scoring_data,
                    rubricReport: scoringData.rubric_report,
                    studentResponse: (this.props.studentResponse?.multipart?.parts.find((responsePart) => {
                        return responsePart && responsePart.question_part_id == partId
                    }) || null),
                    teacherResponse: (this.props.teacherResponse?.multipart?.find((responsePart) => {
                        return responsePart && responsePart.question_part_id == partId
                    })?.teacher_response || null),
                }
            })}
        </div>
    }

    renderPlainPart(part) {
        return <div class="multipart-part-preview">
            {h(part.component("student-facing"), {
                ...this.props, ...{
                    showBody: inlineResponseTypes.includes(part.responseType),
                    item: part,
                    studentResponse: null,
                }
            })}
        </div>
    }

    render() {
        return this.wrapper(
            this.body(),
            this.responseCollector()
        )
    }
}

const performanceEventResponseTypes = [
    "essay",
    "equation",
    "drawing",
    "score-only"
]

/**
 * 
 * @param {import("../../models/question").default} question 
 */
function isTeacherScored(question) {
    if(performanceEventResponseTypes.includes(question.responseType)) {
        return true;
    }
    if(question.responseType == "fill-in-the-blank") {
        return question.correctResponse.scoring_mode == "teacher_scored";
    }

    return false
}
